import { render, staticRenderFns } from "./FlightRequestTab.vue?vue&type=template&id=4280ad05"
import script from "./FlightRequestTab.vue?vue&type=script&lang=js"
export * from "./FlightRequestTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports